module.exports = __webpack_public_path__ + "static/media/27.76ed8bae.jpg";